module.exports = {
    props: ['team', 'pendingInvitations'],

    // data() {
    //     return {
    //         deletingTeamMember: null,

    //         deleteTeamMemberForm: new SparkForm({}),
    //     }
    // },

    // computed: {
    //     /**
    //      * Get the URL for deleting a team member.
    //      */
    //     urlForDeleting() {
    //         return `/settings/${Spark.teamsPrefix}/${this.team.id}/members/${this.deletingTeamMember.id}`;
    //     },
    // },

    methods: {
        /**
         * Cancel the sent invitation.
         */
         sendInvitation(invitation) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            axios.post(`/settings/pendingInvitations`, invitation)
                .then(response => {

                    if(response.data.status){
                        Toast.fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.$parent.$emit('updateInvitations');
                        this.$parent.$emit('updatePendingInvitations');
                    }else{
                        Toast.fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }

                });
        },

        deletePendingInvitations(invitation) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            Swal.fire({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this invitation!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: false,
                closeOnCancel: true,
            }).then((result) => {
                if (result.value) {
            axios.post(`/settings/deletePendingInvitations`, invitation)
                .then(response => {
                    if(response.data.status){
                        Toast.fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.$parent.$emit('updateInvitations');
                        this.$parent.$emit('updatePendingInvitations');
                    }else{
                        Toast.fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }

                });
                }
            });
        },

        // /**
        //  * Display the approval modal for the deletion of a team member.
        //  */
        // approveTeamMemberDelete(member) {
        //     this.deletingTeamMember = member;

        //     $('#modal-delete-member-pending-invitation').modal('show');
        // },

        // /**
        //  * Delete the given team member.
        //  */
        // deleteMember() {
        //     Spark.delete(this.urlForDeleting, this.deleteTeamMemberForm)
        //     .then(() => {
        //         this.$parent.$emit('updatePendingInvitations');

        //         $('#modal-delete-member-pending-invitation').modal('hide');
        //     });
        // },

    }
};
